import { createFileRoute } from "@tanstack/react-router";

import { Coaches } from "@/features/site/modules/coaches/coaches";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/$trainerSlug/coaches/")({
  component: CoachesPage,
  loader: () => ({ crumb: m.landing_nav_coaches() }),
});

function CoachesPage() {
  return <Coaches />;
}
